import { render, staticRenderFns } from "./ChainNearby.vue?vue&type=template&id=c55cdec4&scoped=true&"
import script from "./ChainNearby.vue?vue&type=script&lang=js&"
export * from "./ChainNearby.vue?vue&type=script&lang=js&"
import style0 from "./ChainNearby.vue?vue&type=style&index=0&id=c55cdec4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55cdec4",
  null
  
)

export default component.exports